module.exports = __webpack_public_path__ + "static/img/36.68f71a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/word/36.png
// module id = L+IY
// module chunks = 1